import React from 'react';
import Input from '../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
import CheckboxNew from '../../../../../Core/Fields/Floating/CheckboxNew';

const GeneralDetailsTab1 = ({ formData, onFieldChange, extraData }) => {
    console.log(extraData, "extraData");


    return (
        <div>

            <div className="col-md-12">
                <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                    <div style={{ display: 'flex', gap: '15px' }}>
                        <div style={{ flex: 1 }}>
                            <Input label="Item Code" style={{ height: "30px" }} value={formData.item_Code} onChange={(e) => onFieldChange('item_Code', e.target.value)} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Input label="Item Name" style={{ height: "30px" }} value={formData.item_name} onChange={(e) => onFieldChange('item_name', e.target.value)} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <SelectSearch label="Master Category" style={{ height: "30px" }} value={formData.master_category}
                                onChange={(selectedValue) => onFieldChange('master_category', selectedValue)}
                                list={extraData?.mastercategory}
                                getOptionLabel={(item) => item.value}
                                getOptionValue={(item) => item.value}
                                createNewUrl="/master/itemgroup/create-item-group"
                                createNewLabel="Create Default Unit of Measure"
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <SelectSearch label="HSN/SAC" style={{ height: "30px" }} value={formData.hsn_sac}
                                onChange={(selectedValue) => onFieldChange('hsn_sac', selectedValue)}
                                list={extraData.hsncodedata}
                                getOptionLabel={(item) => item.value}
                                getOptionValue={(item) => item.value}
                                createNewUrl="/master/itemgroup/create-item-group"
                                createNewLabel="Create HSN/SAC"
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '15px' }}>

                        <div style={{ flex: 1 }}>
                            <SelectSearch label="Brand" style={{ height: "30px" }} value={formData.brand} onChange={(selectedValue) => onFieldChange('brand', selectedValue)}
                                list={extraData.branddata}
                                getOptionLabel={(item) => item.value}
                                getOptionValue={(item) => item.value}
                                createNewUrl="/master/itemgroup/create-item-group"
                                createNewLabel="Create Brand"
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <SelectSearch label="Default Unit of Measure" style={{ height: "30px" }} value={formData.default_unit_of_measure} onChange={(e) => onFieldChange('default_unit_of_measure', e.target.value)}
                                list={extraData.compnay}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                createNewUrl="/master/itemgroup/create-item-group"
                                createNewLabel="Bhumika tell no api-right now just keep it"
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Input label="Standard Selling Rate" style={{ height: "30px" }} value={formData.standard_selling_rate} onChange={(e) => onFieldChange('standard_selling_rate', e.target.value)} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Input label="NOS" style={{ height: "30px" }} value={formData.nos} onChange={(e) => onFieldChange('nos', e.target.value)} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Input label="OWS" style={{ height: "30px" }} value={formData.ows} onChange={(e) => onFieldChange('ows', e.target.value)} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <CheckboxNew
                            id="chk1"
                            label="Disabled"
                            labelPosition="right"
                            checked={formData.disabled}
                            onChange={(e) => {
                                onFieldChange('disabled', e.target.checked);
                            }}


                        />
                        <CheckboxNew
                            id="chk2"
                            label="Maintain Stock"
                            labelPosition="right"
                            checked={formData.maintain_stock}
                            onChange={(e) => {
                                onFieldChange('maintain_stock', e.target.checked);
                            }}

                        />
                        <CheckboxNew
                            id="chk1"
                            label="Has Batch No."
                            labelPosition="right"
                            checked={formData.has_batch_no}
                            onChange={(e) => {
                                onFieldChange('has_batch_no', e.target.checked);
                            }}


                        />
                        <CheckboxNew
                            id="chk2"
                            label="Has Serial No."
                            labelPosition="right"
                            checked={formData.has_serial_no}
                            onChange={(e) => {
                                onFieldChange('has_serial_no', e.target.checked);
                            }}
                        />

                        <CheckboxNew
                            id="chk2"
                            label="Has Variants"
                            labelPosition="right"
                            checked={formData.has_variants}
                            onChange={(e) => {
                                onFieldChange('has_variants', e.target.checked);
                            }}
                            helperText="If this item has variants, then it cannot be selected in sales orders etc" />

                    </div>
                </div>
            </div>



        </div>
    );
};

export default GeneralDetailsTab1;